module.exports = __webpack_public_path__ + "static/03-35853f5292ca99848b2a78f004540c37.jpeg";